import {List, fromJS} from 'immutable'

import {
  SET_CURRENT_EXPERT_REVIEWS
} from '../action_types'

const injectKeys = (review, key) => review.merge({key})

const sortByTime = (review) => (review.get('time') || 0) * -1

export default (state = List(), action) => {
  switch (action.type) {
    case SET_CURRENT_EXPERT_REVIEWS:
      return fromJS(action.reviews)
        .map(injectKeys)
        .toList()
        .sortBy(sortByTime)

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/current_expert_reviews.js
 **/